import styled, { css } from 'styled-components'

import { theme } from '@/theme'

import { SIZE, VARIANT } from './constants'

import type { TagProps } from './types'

export const Tag = styled.div.attrs<TagProps>(
  ({ $variant, $size, ...restProps }) => ({
    'data-testid': restProps['data-testid'] ?? 'status-tag',
    ...VARIANT[$variant],
    ...SIZE[$size],
    ...restProps,
  })
)<TagProps>`
  ${({
    $display,
    $items,
    $justify,
    $fs,
    $weight,
    $fg,
    $wSpace,
    $bg,
    $bgOpacity,
    $border,
    $borderColor,
    $radius,
    ...restProps
  }) => css`
    display: ${$display};
    align-items: ${$items};
    justify-content: ${$justify};

    width: fit-content;
    height: fit-content;

    ${theme.helpers.getMarginStyles(restProps)}
    ${theme.helpers.getPaddingStyles(restProps)}

    font-weight: ${theme.fontWeight[$weight]};
    color: ${theme.colors[$fg]};
    ${theme.helpers.getFontSizeStyles($fs)}
    text-align: center;
    white-space: ${$wSpace};

    border: ${theme.border[$border]};
    border-color: ${theme.colors[$borderColor]};
    border-radius: ${theme.radius[$radius]};
    background-color: ${theme.helpers.getColorWithOpacity(
      theme.colors[$bg],
      $bgOpacity
    )};
  `}
`
